import type {SubscriptionProductIds} from '@/types/subscriptions';
import {
  BundlesProductId,
  MyAnalyticsProductId,
  MyContractsProductId,
  MyOrdersProductId,
  MyScanAndPrintProductId,
} from '@/types/subscriptions';

export const isMyAnalyticsProductId = (productId: SubscriptionProductIds): boolean => {
  // @ts-expect-error - TS SubscriptionProductIds are all product ids and we check if this subscription is part of them.
  return Object.values(MyAnalyticsProductId).includes(productId);
};

export const isMyContractsProductId = (productId: SubscriptionProductIds): boolean => {
  // @ts-expect-error - TS SubscriptionProductIds are all product ids and we check if this subscription is part of them.
  return Object.values(MyContractsProductId).includes(productId);
};

export const isMyOrdersProductId = (productId: SubscriptionProductIds): boolean => {
  // @ts-expect-error - TS SubscriptionProductIds are all product ids and we check if this subscription is part of them.
  return Object.values(MyOrdersProductId).includes(productId);
};

export const isMyScanAndPrintProductId = (productId: SubscriptionProductIds): boolean => {
  // @ts-expect-error - TS SubscriptionProductIds are all product ids and we check if this subscription is part of them.
  return Object.values(MyScanAndPrintProductId).includes(productId);
};

export const isBundlesProductId = (productId: SubscriptionProductIds): boolean => {
  // @ts-expect-error - TS SubscriptionProductIds are all product ids and we check if this subscription is part of them.
  return Object.values(BundlesProductId).includes(productId);
};

export const getSubscriptionProductGroupIds = (productId: SubscriptionProductIds): number[] => {
  switch (true) {
    case isMyAnalyticsProductId(productId):
      return Object.values(MyAnalyticsProductId);
    case isMyContractsProductId(productId):
      return Object.values(MyContractsProductId);
    case isMyOrdersProductId(productId):
      return Object.values(MyOrdersProductId);
    case isMyScanAndPrintProductId(productId):
      return Object.values(MyScanAndPrintProductId);
    case isBundlesProductId(productId):
      return Object.values(BundlesProductId);
    default:
      return [];
  }
};
